<div class="layout-gallery">
  @for (i of data().galleryItems; track i.id) {
    <div class="layout-gallery__item" [paiCmsId]="i" [style.--row-count]="i | apply: calcRowCount">
      <div class="layout-gallery__item__inner">
        <picture
          [paiPicture]="i.image"
          size="100vw"
          [sizeMd]="containerInfo().maxWidthAtMd"
          [sizeLg]="containerInfo().maxWidthAtLg"
          [sizeXl]="containerInfo().maxWidthAtXl"
        ></picture>
        @if (i.caption) {
          <p>{{ i.caption }}</p>
        }
      </div>
    </div>
  }
</div>
